import * as companyApi from '../../api/company'
import * as kkvApi from '../../api/kkv'

async function getKkvResult(_, companyId) {
  const kkvCerificationResult = await kkvApi.getDnbKkvCertificationResult(companyId)
  this.dispatch('notify', {
    newNotification: {
      type: 'info',
      message: 'A minősítés eredmény megérkezett.'
    }
  })
  return kkvCerificationResult
}

async function searchCompanies({ commit }, searchParams) {
  try {
    const matchingCompanies = await companyApi.searchCompanies(searchParams)

    commit('setMatchingCompanies', matchingCompanies)
    this.commit('setUserRateLimited', false)
    this.commit('setTooManyResult', false)
  } catch (err) {
    if (err.response.status == 429) {
      this.dispatch('notify', {
        newNotification: {
          type: 'warning',
          message: 'Sajnos túllépte a napi keresési limitet. Kérjük próbálja meg később újból.'
        }
      })
      this.commit('setUserRateLimited', true)
    }
    if (err.response.status == 400) {
      this.commit('setTooManyResult', true)
    }
  }
}

// eslint-disable-next-line no-unused-vars
async function getCompany({ dispatch, commit }, getParams) {
  try {
    this.commit('setSelectedCompanyLoading', true)
    const company = await companyApi.getCompany(getParams)
    this.commit('setSelectedCompany', company)
    //dispatch('notify', { newNotification: { type: 'success', message: 'Cég adatai sikeresen beolvasva.' } })
    this.commit('setUserRateLimited', false)
    this.commit('setTooManyResult', false)
    this.commit('setSelectedCompanyLoading', false)
  } catch (err) {
    if (err.response.status == 429) {
      this.dispatch('notify', {
        newNotification: {
          type: 'warning',
          message: 'Sajnos túllépte a napi keresési limitet. Kérjük próbálja meg később újból.'
        }
      })
      this.commit('setUserRateLimited', true)
    }
    if (err.response.status == 400) {
      this.commit('setTooManyResult', true)
    }
    this.commit('setSelectedCompanyLoading', false)
  }
}

function setMatchingCompanies(state, matchingCompanies) {
  state.matchingCompanies = matchingCompanies
}

function setIsSearchCompany(state, isSearchCompany) {
  state.isSearchCompany = isSearchCompany
}

function setSelectedCompany(state, selectedCompany) {
  state.selectedCompany = selectedCompany
}

function setSelectedCompanyLoading(state, selectedCompanyLoading) {
  state.selectedCompanyLoading = selectedCompanyLoading
}

function nullifySelectedCompanyAction({ commit }) {
  commit('nullifySelectedCompany')
}

function nullifySelectedCompany(state) {
  state.selectedCompany = null
}

function nullifyCompanySuggestionsAction({ commit }) {
  commit('nullifyCompanySuggestions')
}

function nullifyCompanySuggestions(state) {
  state.matchingCompanies = []
}

const companyStore = {
  state: { matchingCompanies: [], selectedCompany: null, isSearchCompany: true, selectedCompanyLoading: true },
  actions: {
    getCompany,
    searchCompanies,
    getKkvResult,
    nullifySelectedCompanyAction,
    nullifyCompanySuggestionsAction
  },
  mutations: {
    setIsSearchCompany,
    setMatchingCompanies,
    setSelectedCompany,
    setSelectedCompanyLoading,
    nullifySelectedCompany,
    nullifyCompanySuggestions
  },
  getters: {
    isSearchCompany: state => {
      return state.isSearchCompany
    },
    companySuggestions: state => {
      return { data: state.matchingCompanies }
    },
    selectedCompany: state => {
      return state.selectedCompany
    },
    companyTerminated: state => {
      const isUnderTermination = !!state.selectedCompany.termination && !!state.selectedCompany.termination.length
      const isUnderSuccessorLessTermination =
        !!state.selectedCompany.successorless_termination && !!state.selectedCompany.successorless_termination.length

      return isUnderTermination || isUnderSuccessorLessTermination
    },
    selectedCompanyLoading: state => state.selectedCompanyLoading
  }
}

export default companyStore
